import Popover from "bootstrap/js/dist/popover";

document.addEventListener("turbo:load", function () {
  let popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]:not(.popover-dismiss)')
  );
  let popoverList = [...popoverTriggerList].map(function (popoverTriggerEl) {
    return new Popover(popoverTriggerEl);
  });

  let popoverDismissTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"].popover-dismiss')
  );
  let popoverDismissList = [...popoverDismissTriggerList].map(function (popoverTriggerEl) {
    return new Popover(popoverTriggerEl);
  });
});
